module.exports = __webpack_public_path__ + "img/publications_banner_gecell.fb427e91.jpg";